var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"q-uploader-input absolute-full cursor-pointer",attrs:{"type":"file","accept":".solution","multiple":""},on:{"change":_vm.addFiles}})}
var staticRenderFns = []

export { render, staticRenderFns }